// extracted by mini-css-extract-plugin
export default {"container":"Rheology_container__nFm5P","creation_block":"Rheology_creation_block__Kyvf+"};